<script lang="ts">
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import {
    addBookmark,
    bookmarks,
    loadBookmarks,
    removeBookmark,
    type BookmarkType
  } from '$lib/store/bookmarksStore';
  import { EventNames } from '$lib/types/analytics';
  import type { NewsCDS, News } from '$lib/types/news';
  import { onMount } from 'svelte';
  import { resetToastStore, toastStoreController } from '$lib/store/index';
  import { TOAST_MESSAGE } from '$lib/constants/text';
  import BookmarkPlaceholder from './BookmarkPlaceholder.svelte';

  export let isBookmarked = false;
  export let newsItem: NewsCDS | News;
  export let postId: string;

  let bookmarksList: BookmarkType[] = [];

  onMount(() => {
    bookmarks.subscribe((bookmark) => {
      bookmarksList = bookmark;
    });
  });

  const handleAddBookMark = () => {
    if (bookmarksList.length >= 10) {
      removeBookmark(bookmarksList[bookmarksList?.length - 1].id);
    }
    if (isBookmarked) {
      removeBookmark(postId);
      isBookmarked = false;
    } else {
      let newsObj: BookmarkType = {
        id: postId,
        ...newsItem
      };
      addBookmark(newsObj);
      // show toast
      toastStoreController(TOAST_MESSAGE, 'info', 'small', '/bookmarks');
      setTimeout(resetToastStore, 2000);
      loadBookmarks();
      sendAnalyticsEvent(EventNames.ARTICLE_BOOKMARKED);
      isBookmarked = true;
    }
  };
</script>

<BookmarkPlaceholder {isBookmarked} {handleAddBookMark} />
